import React, { useMemo } from 'react';
import { useSideTabs } from "../../hooks/useSideTabs";
import Styles from "../../scss/subscriptions.module.scss";
import { DirectMerchantSubscriptions } from "./DirectMerchant";
import { InvoicingContainer } from "./InvoicingContainer";
import { useSubscription } from "../../hooks/useSubscription";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Source } from "./types.d";
import { DisableRouteComponent } from '../util/DisableRouteComponent';
import stripeConfig from '../../config/stripe.config.json';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../reducers';
// import { Redirect } from 'react-router';
// import { NO_PERMISSIONS } from '../../const/URL.const';
import { NoPermission } from '../permissions/NoPermission';

const env = process.env.REACT_APP_ENVIRONMENT ?? "dev";
//@ts-ignore
const stripeKey = stripeConfig[env].key as string;
const stripePromise = loadStripe(stripeKey);

export function SubscriptionsContainer(props: any) {
  const { OnboardingSource } = useSubscription();
  const position = useSideTabs(props.tab);

  const permissions = useSelector((state: IReduxAppState) => state.permissions);

  const useDirectMerchantSubscriptions: boolean = useMemo(() => {
    return OnboardingSource === (Source.Yoello || Source.ZeroBubble || Source.BNA)
  }, [OnboardingSource])

  if (permissions && props.requiredPermission) {
    if (!permissions[props.requiredPermission]) {
      return <NoPermission permission={props.requiredPermission} />;
    }
  }

  return (
    <DisableRouteComponent pageKey={position}>
      <div className={Styles.SubscriptionsContainer}>

        {useDirectMerchantSubscriptions ?
          <DirectMerchantSubscriptions />
          : <Elements stripe={stripePromise}>
            <InvoicingContainer />
          </Elements>
        }
      </div>
    </DisableRouteComponent>

  )
}
